export const BOOKING_CONFIG = {
  // Il channel manager (pagine pubbliche). La prenotazione si apre nella
  // lingua dell'app con la sua pagina localizzata: /{lingua}/book.
  BASE_URL: 'https://book.nonnavittoriaapartments.it',

  // URL del channel manager per Book Now (embedded), senza lingua
  IFRAME_URL: 'https://book.nonnavittoriaapartments.it/book',

  // URL del channel manager per Gift Cards (embedded)
  GIFT_CARD_IFRAME_URL: 'https://book.nonnavittoriaapartments.it/gift-cards',

  // Origini consentite per postMessage (stesse del check-in)
  ALLOWED_ORIGINS: [
    'https://book.nonnavittoriaapartments.it',
    'https://extranet.nonnavittoriaapartments.it',
    'http://localhost:3000',
    'http://localhost:3001'
  ],

  // Timeout per caricamento iframe (30 secondi)
  IFRAME_TIMEOUT: 30000,
};

// Verifica ESATTA dell'origine (solo match esatto per sicurezza)
export const isAllowedBookingOrigin = (origin: string): boolean => {
  return BOOKING_CONFIG.ALLOWED_ORIGINS.includes(origin);
};

/**
 * La prenotazione nell'iframe, nella lingua dell'app: /en/book?embedded=true.
 * La pagina localizzata esiste già sul channel manager (anche in
 * produzione, per la SEO) e fa lo stesso percorso di /book, messaggi
 * compresi. `lang` è già una delle otto lingue dell'app (appLanguageOf).
 */
export const bookingIframeUrl = (lang: string): string =>
  `${BOOKING_CONFIG.BASE_URL}/${encodeURIComponent(lang)}/book?embedded=true`;
